import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {StaticQuery, graphql} from 'gatsby'
import WavyBackground from './WavyBackground'
import WidthContainer from './WidthContainer'
import {QueriedGatsbyImage} from './GatsbyImage'
import {QueryedButton} from './Button'

const RootContainer = styled(WavyBackground)`
`
RootContainer.defaultProps = {
	type: 'gray',
}

const InnerContainer = styled(WidthContainer)`
	padding-top: 1rem;
	padding-bottom: 3rem;
`

const Title = styled.h2`
	margin-bottom: 3.125rem
`


const ListContainer = styled.div`
	display: flex;
	margin: -2rem;
	flex-wrap: wrap;
	
	> * {
		padding: 2rem;
	}
`

const ListItem = styled.div`
	width: 33.333%;
	text-align: center;
	
	@media only screen and (max-width: 1000px) {
		width: 50%;
	}
	
	@media only screen and (max-width: 600px) {
		width: 100%;
	}
`

const ImageContainer = styled.div`
	height: 4.5rem;
`

const ListImage = styled(QueriedGatsbyImage)`
	height: 4.5rem;
	max-width 8rem;
`

const ListName = styled.div`
	font-weight: ${props => props.theme.fontWeights.bold};
	font-size: ${props => props.theme.fontSizes.big20};
	margin-top: 1.2rem;
	margin-bottom: 1.8rem;
`

const ListText = styled.div`
	max-width: 25rem;
	margin: 0 auto;
`

const CtaContainer = styled.div`
	text-align: center;
	margin-top: 3rem;
`

const CtaTitle = styled.div`
	font-weight: ${props => props.theme.fontWeights.bold};
	margin-bottom: 2rem;
`

const CtaButton = styled(QueryedButton)`
`

const SponsorsSection = ({className, withCta}) => <StaticQuery
	query={graphql`{
		sponsorship: file(relativePath: {eq: "pages/sponsorshipPage.json"}) {
			childPagesJson {
			  childPagesJsonWithRelativePaths {
			    sponsors {
					title
					cta {
						title
						button {
							link
							label
						}
					}
					list {
						logo {
						  extension
						  publicURL
						  childImageSharp {
							fixed(height: 75) {
							  ...GatsbyImageSharpFixed
							}
						  }
						}
						name
						text
					}
				}
			  }
		  	}
		}
	 }`}
	render={(rawData) => {
		const data = rawData.sponsorship.childPagesJson.childPagesJsonWithRelativePaths.sponsors
		return <RootContainer className={className}>
			<InnerContainer>
				<Title>{data.title}</Title>
				<ListContainer>
					{data.list.map(one => <ListItem key={one.title}>
						<ImageContainer>
							<ListImage image={one.logo}/>
						</ImageContainer>
						<ListName>{one.name}</ListName>
						<ListText>{one.text}</ListText>
					</ListItem>)}
				</ListContainer>

				{withCta && <CtaContainer>
					<CtaTitle>{data.cta.title}</CtaTitle>
					<CtaButton data={data.cta.button}/>
				</CtaContainer>}
			</InnerContainer>
		</RootContainer>
	}}/>

SponsorsSection.propTypes = {
	className: PropTypes.string,
	withCta: PropTypes.bool,
}

SponsorsSection.defaultProps = {
	className: '',
	withCta: false,
}

export default SponsorsSection
